import React from "react";
import PropTypes from "prop-types";
import { Caution } from "./Caution";
import { Board } from "./Board";
import { Switch } from "./Switch";
import { Warning } from "./Warning";
import { SWITCHED_OFF, SWITCHED_ON } from "./style.module";

export function MainContent(props) {
  const style = props.switchedOn ? SWITCHED_ON : SWITCHED_OFF;

  return (
    <div style={style.content}>
      <div style={style.content_left}>
        <Caution style={style.content_left__caution} />
        <p style={style.content_left__text}>Turn on the transilluminator</p>
        <Warning style={style.content_left__warning} />
        <Switch
          style={style.content_left__switch}
          onClick={props.onToggleSwitch}
          switchedOn={props.switchedOn}
        />
      </div>
      <div style={style.content_right}>
        <Board style={style} switchedOn={props.switchedOn}>
          {props.component}
        </Board>
      </div>
    </div>
  );
}

MainContent.propTypes = {
  /**
   * Boolean to specify if Apparatus turned ON/OFF
   */
  switchedOn: PropTypes.bool,
  /**
   * Component to dispaly inside the UVTransilluminator board
   */
  component: PropTypes.element,
  /**
   * Function to invoke wnen switch is toggled
   */
  onToggleSwitch: PropTypes.func,
};
